import { render, staticRenderFns } from "./PotentialImpacts.vue?vue&type=template&id=386e3e1a"
import script from "./PotentialImpacts.vue?vue&type=script&lang=js"
export * from "./PotentialImpacts.vue?vue&type=script&lang=js"
import style0 from "./PotentialImpacts.vue?vue&type=style&index=0&id=386e3e1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports